module.exports = __webpack_public_path__ + "static/media/ms-teams.946fe37b.svg";